import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { TopAppBarMenu, TopAppBarLogo, AccountDropdownMenu } from ".";
import { menuItems } from "./";
import { Grid } from "@mui/material";

// Create separate routes for all forms fetching based on user role requesting it

export const ResponsiveAppBar = () => {
  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "rgb(243,243,243)",
        display: { xs: "flex", md: "none" },
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          mx: 2,
          my: { md: -1 },
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <TopAppBarLogo />
        <Grid>
          {/* This is a responsive menu, each component has breakpoints defined for display inside them */}
          <TopAppBarMenu menuItems={menuItems} />
          <AccountDropdownMenu menuItems={menuItems} />
        </Grid>
      </Toolbar>
    </AppBar>
  );
};
